module.exports = __webpack_public_path__ + "static/media/1.ec7e2e30.JPG";